import { ApplicationConfig, APP_INITIALIZER, inject } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { ApiConfigService, AuthInterceptor, provideI18n } from '@shared';

function initializeApiConfig() {
  return () => {
    const apiConfig = inject(ApiConfigService);
    apiConfig.setApiUrl(environment.apiUrl);
    apiConfig.setWsUrl(environment.wsUrl);
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi()),
    provideI18n(),
    provideIonicAngular({ mode: 'md' }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initializeApiConfig, multi: true },
  ],
};
